import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import SignupStep from '../components/funnel/SignupStep';
import ResumeStep from '../components/funnel/ResumeStep';
import { useAuth } from '../contexts/AuthContext';
import { trackFunnelStep2 } from '../utils/analytics';

export default function GetOffersFunnel() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [currentStep, setCurrentStep] = useState(1);
  const [fileName, setFileName] = useState('');
  const [resumeContent, setResumeContent] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [salary, setSalary] = useState(120000);
  const [experience, setExperience] = useState(3);

  // Фейковая загрузка файла
  const handleFileUpload = async (file: File) => {
    setIsLoading(true);
    setFileName(file.name);
    setUploadProgress(0);
    setResumeContent('fake-content');
    // Имитация загрузки 1.5 сек
    let progress = 0;
    const interval = setInterval(() => {
      progress += 20;
      setUploadProgress(Math.min(progress, 100));
      if (progress >= 100) {
        clearInterval(interval);
        setIsLoading(false);
      }
    }, 300);
  };

  const handleContinue = () => {
    if (currentStep === 1) {
      setCurrentStep(2);
    } else {
      navigate('/getoffers/pricing');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-4xl mx-auto">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentStep}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            {currentStep === 1 ? (
              <SignupStep onContinue={handleContinue} />
            ) : (
              <ResumeStep
                fileName={fileName}
                resumeContent={resumeContent}
                uploadProgress={uploadProgress}
                isLoading={isLoading}
                onFileUpload={handleFileUpload}
                onContinue={handleContinue}
                salary={salary}
                setSalary={setSalary}
                experience={experience}
                setExperience={setExperience}
              />
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
} 